import React from 'react';
import { isNil } from 'ramda';
import { Formik } from 'formik';

import Modal from '../../../../components/Modal';
import {
  validationSchema,
  initialValues,
} from '../../../../forms/invoice/settingsForm';
import { ErrorFlash } from '../../../../components';

import EditInvoiceSettingsForm from './components/EditInvoiceSettingsForm';

const EditInvoiceSettingsModal = (props) => {
  const { onModalClose, isModalOpen, onSubmit, settings, errors } = props;
  return (
    <Modal
      title="Edit Invoice Settings"
      onClose={onModalClose}
      onSave={onSubmit}
      isModalOpen={isModalOpen}
    >
      {!isNil(errors) && <ErrorFlash errors={errors} message={errors} />}
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => onSubmit(values, actions)}
        initialValues={initialValues(settings)}
        validationSchema={validationSchema}
        render={(formikProps) => (
          <EditInvoiceSettingsForm
            {...formikProps}
            onModalClose={onModalClose}
          />
        )}
      />
    </Modal>
  );
};

export default EditInvoiceSettingsModal;
